import type { AIProvider, Tab, TabId } from './types';


export const DEFAULT_MODELS: Record<AIProvider, string> = {
  managed: 'gpt-5.4',
  gemini: 'gemini-3-flash-preview',
  openai: 'gpt-5.3-chat-latest',
  anthropic: 'claude-sonnet-4-6',
  ollama: 'llama3.2',
};

export const TABS: Tab[] = [
  { id: 'people', label: 'Contacts', icon: 'people' },
  { id: 'moves', label: 'Moves', icon: 'task_alt' },
  { id: 'reflections', label: 'Reflections', icon: 'auto_stories' },
  { id: 'settings', label: 'Settings', icon: 'settings' },
];

export const DEFAULT_TAB: TabId = 'people';

export const DEFAULT_STUDIO_URL = 'https://studio.clawer.app';
